import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-d', 'IconLetterD', [
  ['path', { d: 'M7 4h6a5 5 0 0 1 5 5v6a5 5 0 0 1 -5 5h-6v-16', key: 'svg-0' }],
]);
